__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "janus-idp.backstage-plugin-jfrog-artifactory";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@backstage/core-plugin-api", "1.9.2", () => (Promise.all([__webpack_require__.e(5124), __webpack_require__.e(5478), __webpack_require__.e(7326), __webpack_require__.e(1638)]).then(() => (() => (__webpack_require__(11638))))));
			register("@backstage/version-bridge", "1.0.8", () => (Promise.all([__webpack_require__.e(5478), __webpack_require__.e(7388)]).then(() => (() => (__webpack_require__(97388))))));
			register("@material-ui/core/styles", "4.12.4", () => (Promise.all([__webpack_require__.e(4491), __webpack_require__.e(5478), __webpack_require__.e(1942)]).then(() => (() => (__webpack_require__(64491))))));
			register("@material-ui/styles", "4.11.5", () => (Promise.all([__webpack_require__.e(5414), __webpack_require__.e(5478), __webpack_require__.e(355)]).then(() => (() => (__webpack_require__(15414))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(3144), __webpack_require__.e(5478)]).then(() => (() => (__webpack_require__(43144))))));
			register("react-router-dom", "6.23.0", () => (Promise.all([__webpack_require__.e(1613), __webpack_require__.e(3657), __webpack_require__.e(5478), __webpack_require__.e(484), __webpack_require__.e(9829)]).then(() => (() => (__webpack_require__(73657))))));
			register("react-router", "6.23.0", () => (Promise.all([__webpack_require__.e(1613), __webpack_require__.e(8690), __webpack_require__.e(5478)]).then(() => (() => (__webpack_require__(18690))))));
			register("react", "18.3.1", () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(14041))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};